var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMixtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60.000000pt",
    height: "60.000000pt",
    viewBox: "0 0 60.000000 60.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,60.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 300 l0 -300 300 0 300 0 0 300 0 300 -300 0 -300 0 0 -300z m81 238 c22 -82 77 -140 158 -164 118 -36 240 32 277 154 13 44 19 52 40 52 29 0 31 -17 7 -86 -35 -102 -151 -184 -263 -184 -112 0 -228 82 -263 184 -24 69 -22 86 8 86 20 0 26 -7 36 -42z m69 25 c0 -29 37 -82 72 -103 43 -26 113 -26 156 0 35 21 72 74 72 103 0 12 8 17 30 17 36 0 37 -9 6 -76 -25 -54 -69 -94 -125 -113 -103 -34 -223 30 -260 138 -16 48 -15 51 19 51 22 0 30 -5 30 -17z m82 -13 c30 -53 106 -53 136 0 12 22 25 30 45 30 l27 0 -15 -37 c-19 -47 -45 -70 -96 -83 -70 -19 -159 39 -159 105 0 27 44 17 62 -15z m128 23 c0 -17 -36 -43 -58 -43 -25 0 -62 25 -62 42 0 4 27 8 60 8 33 0 60 -3 60 -7z m-226 -230 l48 -33 -81 0 -81 0 0 81 0 81 33 -48 c18 -26 55 -63 81 -81z m446 47 l0 -80 -81 0 -81 0 48 33 c27 18 62 54 79 80 16 25 31 46 33 46 1 1 2 -35 2 -79z m0 -235 l0 -135 -280 0 -280 0 0 135 0 135 280 0 280 0 0 -135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 200 c0 -8 -5 -34 -9 -57 -10 -49 4 -59 14 -11 l7 31 15 -34 14 -34 17 30 17 30 3 -27 c2 -16 8 -28 13 -28 10 0 3 84 -8 104 -3 4 -13 -9 -23 -30 l-17 -39 -21 40 c-12 22 -22 33 -22 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 155 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55 -5 0 -10 -25 -10 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 183 c16 -24 16 -28 1 -55 -10 -15 -13 -28 -7 -28 5 0 14 8 20 17 9 17 11 16 30 -1 24 -22 26 -18 10 17 -8 18 -8 30 1 47 15 27 4 40 -13 16 -12 -16 -14 -16 -26 -2 -22 26 -35 18 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 200 c0 -5 5 -10 10 -10 6 0 10 -20 10 -45 0 -25 5 -45 10 -45 6 0 10 20 10 45 0 33 4 45 15 45 8 0 15 5 15 10 0 6 -16 10 -35 10 -19 0 -35 -4 -35 -10z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixtLogo);
export default __webpack_public_path__ + "static/media/Mixt-logo.146f409e.svg";
export { ForwardRef as ReactComponent };